import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents';
import { CommonDialogV2 } from '@ifca-root/react-component/src/components/Dialog/CommonDialogV2';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { LHDNBuyerDetailsForm } from './LHDNBuyerForm';
import { Box } from '@material-ui/core';
import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import QRCode from 'qrcode.react';
import { PaymentClass, useGetbuyerInfoLazyQuery } from 'generated/graphql';

interface DialogProps {
	openExitDialog: boolean;
	setOpenExitDialog: any;
	backPath: string;
	handleSubmit?: any;
	onSubmit?: any;
	selectedCredit?: any;
	selectedDebtor?: any;
	data?: any;
	stateItem?: any;
	cardType?: any;
	cardReference?: any;
	filesLHDN?: any;
	selectedRoom?: any;
	selectedNonGuest?: any;
	selectedFolio?: any;
	remark?: string;
	selectedOfficer?: any;
	selectedStaff?: any;
	buyerInfoQR?: any;
	buyerInfoQRLoading?: any;
	outletID?: any;
	orderID?: any;
	setIsBuyerDetails?: any;
	dispatch?: any;
	isSignature?: any;
	setSelectedPaymentsign?: any;
}

export const LHDNconfirmationDialog = (props: DialogProps) => {
	const {
		openExitDialog,
		setOpenExitDialog,
		backPath,
		handleSubmit,
		onSubmit,
		selectedCredit,
		selectedDebtor,
		data,
		stateItem,
		cardType,
		cardReference,
		filesLHDN,
		selectedRoom,
		selectedNonGuest,
		selectedFolio,
		remark,
		selectedOfficer,
		selectedStaff,
		buyerInfoQR,
		buyerInfoQRLoading,
		outletID,
		orderID,
		dispatch,
		setSelectedPaymentsign,
	} = props;

	let history = useHistory();

	const [isBuyerDetails, setIsBuyerDetails] = useState(false);

	const [
		loadbuyerInfo,
		{
			loading: buyerInfoLoading,
			data: { getbuyerInfo } = { getbuyerInfo: false },
		},
	] = useGetbuyerInfoLazyQuery({
		fetchPolicy: 'network-only',
	});

	useEffect(() => {
		if (openExitDialog === true) {
			loadbuyerInfo({
				variables: {
					outletID: outletID,
					orderID: orderID,
				},
			});
		}
	}, [openExitDialog]);

	const isSignature = () => {
		const isSignature =
			data?.filter(
				x =>
					x?.paymentClass === PaymentClass.Room ||
					x?.paymentClass === PaymentClass.Debtor ||
					x?.paymentClass === PaymentClass.NonGuest ||
					x?.paymentClass === PaymentClass.SuspendFolio ||
					x?.paymentClass === PaymentClass.Member,
			)?.length > 0
				? true
				: false;

		return isSignature;
	};

	console.log('ID >>>', outletID, orderID);

	const LHDNUrlConfigs: Record<string, string> = {
		promenade: 'https://promenade.menux.asia/',
		'promenade-staging': 'https://promenade-uat.menux.asia/',
		imperial: 'https://imperial.menux.asia/',
		'imperial-staging': 'https://imperial-uat.menux.asia/',
		dev: 'https://posx-dev-outlet.ifca.io/',
		local: 'http://localhost:3250/',
		uat: 'https://menux-uat-outlet.menux.asia/',
		swan: 'https://swan.menux.asia/',
		swanuat: 'https://swan-menux-uat.menux.asia/',
		edu: 'https://edu.menux.asia/',
		prod: 'https://outlet.menux.asia/',
		pkns: 'https://pos.menux.asia/',
		'pkns-uat': 'https://pos-uat.menux.asia/',
		outlet1: 'https://outlet1.menux.asia/',
		outlet2: 'https://outlet2.menux.asia/',
		outlet3: 'https://outlet3.menux.asia/',
	};

	const currentEnv =
		process.env.REACT_APP_ENV ||
		(typeof window !== 'undefined' && (window as any).__APP_ENV__) ||
		'prod';

	const qrUrl = `${LHDNUrlConfigs[currentEnv] ||
		LHDNUrlConfigs.prod}buyer-info/${outletID}/${orderID}`;

	return (
		<>
			{buyerInfoQRLoading && <Loading />}

			<CommonDialogV2
				fullWidth={true}
				open={openExitDialog}
				onClose={() => setOpenExitDialog(false)}
				sections={{
					header: {
						dynamic: (
							<div className="">
								<div className="dialog-dynamic-content">
									<div className="session">
										<div className="title">LHDN GUIDELINE</div>
									</div>
								</div>
							</div>
						),
					},
					body: () => (
						<>
							{/* <CardContents> */}
							{(selectedDebtor && selectedDebtor?.IsIndividual === false) ||
							(selectedFolio &&
								selectedFolio?.DebtorInfo?.IsIndividual === false) ||
							(selectedNonGuest &&
								selectedNonGuest?.DebtorInfo?.IsIndividual === false) ? (
								<span className="mdDesc" style={{ whiteSpace: 'initial' }}>
									As per LHDN Guideline, any single transaction above RM10,000
									must be submitted as Individual e-Invoice. Please update
									debtor profile before proceed the transaction. Click on
									“Confirm” to return to payment screen.
								</span>
							) : getbuyerInfo === false ? (
								<>
									<span>
										<span
											className="fs-14 text-noflow"
											style={{ textAlign: 'justify' }}
										>
											As per LHDN Guideline, any single transaction above{' '}
											<b>RM10,000</b> must be submitted as{' '}
											<b>Individual e-Invoice</b>.{' '}
											{` Kindly share the QR code with your guest to allow them to update their information accordingly.`}
										</span>
									</span>

									<Box
										sx={{
											display: 'flex',
											justifyContent: 'center',
											mt: 2,
										}}
									>
										<QRCode
											value={qrUrl}
											// value={data}
											size={128}
											bgColor={'#ffffff'}
											fgColor={'#000000'}
											level={'M'}
											includeMargin={false}
										/>
									</Box>

									{/* <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  mt: 2,
                }}
              >
                <img 
                  src={qrUrl} 
                  width="120px" 
                  height="120px" 
                />
              </Box> */}
								</>
							) : (
								<span className="mdDesc" style={{ whiteSpace: 'initial' }}>
									Would you like to proceed?
								</span>
							)}
							{/* </CardContents> */}
						</>
					),
					footer: {
						actions: [
							{
								displayText: 'Close',
								props: {
									onClick: () => setOpenExitDialog(false),
									variant: 'contained',
									color: 'primary',
								},
							},
							{
								displayText: 'Confirm',
								props: {
									name: 'LHDN',

									onClick: async () => {
										const isCompanyDebtor =
											(selectedDebtor &&
												selectedDebtor?.IsIndividual === false) ||
											(selectedFolio &&
												selectedFolio?.DebtorInfo?.IsIndividual === false) ||
											(selectedNonGuest &&
												selectedNonGuest?.DebtorInfo?.IsIndividual === false);

										if (isCompanyDebtor) {
											setOpenExitDialog(false);
											return;
										}

										// Re-check after guest may have filled buyer details via QR
										const result = await loadbuyerInfo({
											variables: {
												outletID: outletID,
												orderID: orderID,
											},
										});
										const hasBuyerInfo = result?.data?.getbuyerInfo === true;

										// Buyer details not filled yet → close and return to payment
										if (!hasBuyerInfo) {
											setOpenExitDialog(false);
											return;
										}

										// Buyer details filled, still on QR step → stay open and show
										// "Would you like to proceed?"
										if (getbuyerInfo !== true) {
											return;
										}

										// Second Confirm on "Would you like to proceed?" → submit payment
										setOpenExitDialog(false);

										handleSubmit(formData => {
											if (isSignature() && !filesLHDN) {
												setSelectedPaymentsign?.(formData);
												dispatch?.({ type: 'signatureDialog', payload: true });
												return;
											}

											const signedPayments =
												Array.isArray(data) && data.length > 0
													? data.map(p => ({ ...p, selected: true }))
													: null;

											onSubmit(
												{
													...formData,
													defaultPayment:
														signedPayments ?? formData?.defaultPayment,
												},
												filesLHDN,
											);
										})();
									},

									variant: 'contained',
									color: 'primary',
								},
							},
						],
					},
				}}
			/>
			{isBuyerDetails === true && (
				<LHDNBuyerDetailsForm
					selectedDebtor={selectedDebtor}
					data={data}
					stateItem={stateItem}
					selectedCredit={selectedCredit}
					cardType={cardType}
					cardReference={cardReference}
					filesLHDN={filesLHDN}
					selectedRoom={selectedRoom}
					selectedNonGuest={selectedNonGuest}
					selectedFolio={selectedFolio}
					remark={remark}
					selectedOfficer={selectedOfficer}
					selectedStaff={selectedStaff}
				/>
			)}
		</>
	);
};
